import React from 'react'

import {
    Row,
    Col,
    Button,
    Card,
    message,
    Tabs
} from 'antd'

import { 
    _getDoc,
    _getDocCategories,
    _postNewDocCategory,
    _postAddDocSubCategory,
    _postRemoveDocCategory,
    _postRemoveDocSubCategory,
    _postNewDoc,
    _postUpdateDoc
} from '../../services'

import AddCategory from './add-category'
import DocCategoryTable from './category-table'
import ArticleTable from './article-table'
import Editor from './editor'

const { TabPane } = Tabs

const SOURCE = "doc"

class Docs extends React.Component {

    render(){

        return (
            <Card>
                <Tabs
                    onChange={(activeTab) => {
                        this.setState({
                            activeTab
                        }, () => window.history.pushState(null, null, `/docs/${activeTab}${this.state.activeDoc && activeTab == "editor"?`/${this.state.activeDoc._id}`:''}`))
                    }}
                    activeKey={this.state.activeTab}
                >
                    <TabPane tab="Categories" key="categories">
                        <Card
                            title={<Row type="flex" justify="space-between">
                                    <Col>Document Categories</Col>
                                    <Col>
                                        <AddCategory
                                            buttonText="Add Main Category"
                                            handleSubmit={this.handleAddMainCategory}
                                        />
                                    </Col>
                                </Row>}
                        >
                        {<DocCategoryTable
                            removeDocSubCategory={this.handleRemoveSubCategory}
                            removeDocCategory={this.handleRemoveMainCategory}
                            loading={this.state.loading}
                            handleAddSubCategory={this.handleAddSubCategory}
                            docCategories={this.state.docCategories}
                        />}
                        </Card>
                    </TabPane>
                    <TabPane tab="Articles" key="articles">
                        {this.state.activeTab == 'articles' && <ArticleTable/>}
                    </TabPane>
                    <TabPane tab="Editor" key="editor">
                        <Editor
                            getExcerpt={this._getExcerpt}
                            loading={this.state.docLoading}
                            activeDoc={this.state.activeDoc}
                            handlePost={this.handleCreateArticle}
                            handleSave={this.handleSaveArticle}
                            source={SOURCE}
                        />
                    </TabPane>
                </Tabs>
            </Card>
        )
    }

    constructor(props){
        super(props)

        this.state = {
            docCategories: [],
            loading: true,
            docLoading: true,
            activeTab: 'categories',
            activeDoc: false
        }

        this.getDocCategories()
    }

    componentDidMount(){

        if( this.props.docId ){
            _getDoc(this.props.docId)
            .then( res => {
                this.setState({
                    activeDoc: res.data.doc,
                    docLoading: false
                })
            })
        } else {
            this.setState({ docLoading: false })
        }
            
        this.setState({
            activeTab: this.props.activeTab || 'categories'
        })
    }

    getDocCategories = () => {
        _getDocCategories()
        .then( res => {
            this.setState({
                loading: false,
                docCategories: res.data.docCategories
            })
        })
    }

    handleCreateArticle = ({title, content}) => {

        const excerpt = this._getExcerpt(content)

        const text = JSON.stringify(content)

        this.setState({ docLoading: true })

        _postNewDoc({title, excerpt, text})
        .then( res => {
            message.success(`${title} posted!`)
            this.setState({docLoading: false})
            window.open(`/docs/editor/${res.data.doc._id}`)
        })
    }

    handleSaveArticle = ({title, content}) => {

        const excerpt = this._getExcerpt(content)

        const text = JSON.stringify(content)
        this.setState({ docLoading: true })

        _postUpdateDoc({title, text, excerpt, docId: this.props.docId})
        .then( res => {
            this.setState({
                docLoading: false,
                activeDoc: res.data.doc
            })
            message.success(`${title} saved!`)
        })

    }

    handleAddSubCategory = (docCategoryId, subTitle) => {

        _postAddDocSubCategory({subTitle, docCategoryId})
        .then( res => {
            this.getDocCategories()
            message.success('Sub Category Added')
        })
    }

    handleAddMainCategory = (mainTitle) => {
        _postNewDocCategory(mainTitle)
        .then( res => {
            this.getDocCategories()
            message.success('Main Category Added')
        })
    }

    handleRemoveSubCategory = (docCategoryId, docSubCategoryId) => {

        _postRemoveDocSubCategory({ docCategoryId, docSubCategoryId })
        .then( res => {
            this.getDocCategories()
            window.location.reload()
        })
    }

    handleRemoveMainCategory = (docCategoryId) => {

        _postRemoveDocCategory(docCategoryId)
        .then( res => {
            this.getDocCategories()
            window.location.reload()
        })

    }

    _getExcerpt = (content) => {

        return content.blocks.reduce( (_excerpt, _block ) => {

            if( _block.type == 'unstyled'){
                _excerpt += _block.text
            }

            return _excerpt

        }, "").slice(0, 400)

    }
}

export default Docs


// WEBPACK FOOTER //
// ./src/components/docs/index.js